import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { notifications } from '@mantine/notifications';
import { FileType } from '../types/fileType';
import { FileResponse } from '.';
import { v4 } from 'uuid'

export type UploadFileDTO = {
    data: {
        asset: File;
        name: string;
        type: FileType;
        client: {
            uuid: string;
            name: string;
            acronym: string;
        }
    }
}

export const uploadFile = ({ data }: UploadFileDTO): Promise<FileResponse> => {

    const folder = `${import.meta.env.VITE_S3_ROOT}/${data.type}/`
    const fileName = `${data.client.uuid}_${data.client.acronym}_${v4()}_${data.name}` 

    return axios.post('/clouds/aws/s3/upload', {
        asset: data.asset,
        name: fileName,
        folder: folder
    }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    .then((result: any) => {
        if (!result)
            throw new Error('An error occured while uploading the file.')
        return result
    })
};

type UseUploadFileOptions = {
    config?: MutationConfig<typeof uploadFile>;
};

export const useUploadFile = ({ config }: UseUploadFileOptions = {}) => {
    return useMutation({
        onMutate: async (newFile) => {
            await queryClient.cancelQueries('files');

            const previousFiles = queryClient.getQueryData<Event[]>('events');

            queryClient.setQueryData('files', [...(previousFiles || []), newFile.data]);

            return { previousFiles };
        },
        onError: (_,__, context: any) => {
            if (context?.previousFiles) {
                queryClient.setQueryData('files', context.previousFiles);
            }
            notifications.show({
                title: 'Error',
                message: 'An error occurred while uploading the file ❌',
                color: 'red'
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries('files');
            notifications.show({
                title: 'Success!',
                message: 'File uploaded ✅',
                color: 'green'
            });
        },
        ...config,
        mutationFn: uploadFile,
    });
}